import { render, staticRenderFns } from "./ReportingPageIntro.vue?vue&type=template&id=0c8ef2c1"
import script from "./ReportingPageIntro.vue?vue&type=script&lang=js"
export * from "./ReportingPageIntro.vue?vue&type=script&lang=js"
import style0 from "./ReportingPageIntro.vue?vue&type=style&index=0&id=0c8ef2c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports